import { ChangeEvent, FormEvent, Component } from "react";
import axios from "axios";
import * as config from "../../config";

interface Option {
  label: string;
  children: { [key: string]: string };
}

const options: Option[] = [
  {
    label: "Remote Control",
    children: {
      AuxBattery: "/C2V/OEMSW/remoteservices/remoteac/request",
      Buzzer: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Chargelid: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      DigitalKey: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Door: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Hazard: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Headlights: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Horn: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      Powerwindow: "/C2V/OEMSW/remoteservices/remotecontrol/request",
      RemoteClimate: "/C2V/OEMSW/remoteservices/remoteac/request",
      Sunroof: "/C2V/OEMSW/remoteservices/remotecontrol/request",
    },
  },
  {
    label: "Vehicle Status",
    children: {
      DigitalKey: "/C2V/OEMSW/remoteservices/digitalkey/data-request",
      ElectricSupply: "/C2V/OEMSW/remoteservices/electricsupply/data-request",
      ForgetInform: "/C2V/OEMSW/remoteservices/forgetinform/data-request",
      OptimumCharge: "/C2V/OEMSW/remoteservices/optimumcharge/data-request",
      RemoteCharge: "/C2V/OEMSW/remoteservices/charge/data-request",
      RemoteClimate: "/C2V/OEMSW/remoteservices/remoteac/data-request",
      RemoteConfirm: "/C2V/OEMSW/remoteservices/remotecheck/data-request",
      SolarCharge: "/C2V/OEMSW/remoteservices/solarcharge/data-request",
    },
  },
  {
    label: "EConnect",
    children: {
      AutomaticChargingDiscovery:
        "/C2V/OEMSW/remoteservices/autocharge/request",
      AutomaticChargingLidControl:
        "/C2V/OEMSW/remoteservices/autocharge/request",
      AutomaticChargingPassword: "/C2V/OEMSW/remoteservices/autocharge/request",
      ChargelidConnector: "/C2V/OEMSW/remoteservices/charge/request",
      ChargeSetting: "/C2V/OEMSW/remoteservices/charge/request",
      ElectricSupplySettings:
        "/C2V/OEMSW/remoteservices/electricsupply/request",
      OptimumCharging: "/C2V/OEMSW/remoteservices/optimumcharge/request",
      NextChargingTimer: "/C2V/OEMSW/remoteservices/charge/request",
      ChargeCreateSchedule: "/C2V/OEMSW/remoteservices/charge/request",
      ChargeUpdateSchedule: "/C2V/OEMSW/remoteservices/charge/request",
    },
  },
  {
    label: "Drive Monitor",
    children: {
      GuestDriverMonitor_Setting:
        "/C2V/OEMSW/remoteservices/provisioning/event-table-setting",
      Trip_Setting:
        "/C2V/OEMSW/remoteservices/provisioning/event-table-setting",
      UBI_Setting: "/C2V/OEMSW/remoteservices/provisioning/event-table-setting",
      GuestDriverMonitor_DataUpload:
        "/C2V/OEMSW/remoteservices/guestdrivermonitor/data-request",
      Trip_DataUpload: "/C2V/OEMSW/remoteservices/trip/data-request",
      UBI_DataUpload: "/C2V/OEMSW/remoteservices/ubi/data-request",
    },
  },
];

interface PFProps {
  jwtToken: string;
}

class PayloadForm extends Component<PFProps>  {
  state = {
    topic: "",
    subTopic: "",
    requestPayload: "",
    resultPayload: "",
    scenarioId: "",
    description: "",
    submitting: false,
    notification: null as string | null,
    };

  handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.setState({ submitting: true });

    try {
      const {
        topic,
        subTopic,
        requestPayload,
        resultPayload,
        scenarioId,
        description,
        } = this.state;
      const response = await axios.post(
        config.rootUrl + "/v1/simulator/vehicle-payload",
        {
          topic,
          subTopic:
            options.find((option) => option.label === topic)?.children[
              subTopic
            ] || "",
          requestPayload,
          resultPayload,
          scenarioId,
          description,
        },
        { headers: { "x-api-key": config.apiKey, Authorization: "Bearer " + this.props.jwtToken } },
      );

      console.log("Payload submitted successfully:", response.data);
      this.setState({ notification: "Record added successfully!" });
      setTimeout(() => {
        this.setState({ notification: null });
      }, 3000);

      this.setState({
        topic: "",
        subTopic: "",
        requestPayload: "",
        resultPayload: "",
        scenarioId: "",
        description: "",
      });
    } catch (error) {
      console.error("Error submitting payload:", error);
      this.setState({ notification: "Error adding record. Please try again." });
    } finally {
      this.setState({ submitting: false });
    }
  };

  handleTopicChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const selectedTopic = event.target.value;
    this.setState({ topic: selectedTopic, subTopic: "" });
  };

  handleSubTopicChange = (event: ChangeEvent<HTMLSelectElement>) => {
    this.setState({ subTopic: event.target.value });
  };

  render() {
    const {
      topic,
      subTopic,
      requestPayload,
      resultPayload,
      scenarioId,
      description,
      submitting,
      notification,
    } = this.state;

    return (
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "20px",
        }}
      >
        <h2 style={{ fontSize: "24px", marginBottom: "20px" }}>
          Submit Payload
        </h2>

        {notification && (
          <div
            style={{
              backgroundColor: notification.includes("Error")
                ? "#dc3545"
                : "#28a745",
              color: "#fff",
              padding: "10px",
              borderRadius: "4px",
              marginBottom: "20px",
            }}
          >
            {notification}
          </div>
        )}

        <form onSubmit={this.handleSubmit} style={{ marginBottom: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div style={{ flex: 1, marginRight: "10px" }}>
              <label
                htmlFor="topic"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "16px",
                }}
              >
                Topic:
              </label>
              <select
                id="topic"
                value={topic}
                onChange={this.handleTopicChange}
                style={{
                  width: "100%",
                  padding: "5px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                }}
                required
              >
                <option value="" disabled>
                  Select Topic
                </option>
                {options.map((option, index) => (
                  <option key={index} value={option.label}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ flex: 1, marginLeft: "10px" }}>
              <label
                htmlFor="subTopic"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "16px",
                }}
              >
                Subtopic:
              </label>
              <select
                id="subTopic"
                value={subTopic}
                onChange={this.handleSubTopicChange}
                style={{
                  width: "100%",
                  padding: "5px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                }}
                required
                disabled={!topic}
              >
                <option value="" disabled>
                  Select Subtopic
                </option>
                {(options.find((option) => option.label === topic)?.children ||
                  {}) &&
                  Object.keys(
                    options.find((option) => option.label === topic)
                      ?.children || {},
                  ).map((child, index) => (
                    <option key={index} value={child}>
                      {child}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div style={{ display: "flex", marginBottom: "20px" }}>
            <div style={{ flex: "0 0 30%", marginRight: "10px" }}>
              <label
                htmlFor="scenarioId"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "16px",
                }}
              >
                Scenario ID:
              </label>
              <input
                type="text"
                id="scenarioId"
                value={scenarioId}
                onChange={(e) => this.setState({ scenarioId: e.target.value })}
                style={{
                  width: "100%",
                  padding: "5px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                }}
                required
              />
            </div>

            <div style={{ flex: "0 0 70%" }}>
              <label
                htmlFor="description"
                style={{
                  display: "block",
                  marginBottom: "5px",
                  fontSize: "16px",
                }}
              >
                Description:
              </label>
              <input
                type="text"
                id="description"
                value={description}
                onChange={(e) => this.setState({ description: e.target.value })}
                style={{
                  width: "100%",
                  padding: "5px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                }}
                required
              />
            </div>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="requestPayload"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
              }}
            >
              Request Payload:
            </label>
            <textarea
              id="requestPayload"
              placeholder="Request Payload"
              value={requestPayload}
              onChange={(e) =>
                this.setState({ requestPayload: e.target.value })
              }
              style={{
                width: "100%",
                padding: "5px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
              }}
              required
              rows={3}
            ></textarea>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="resultPayload"
              style={{
                display: "block",
                marginBottom: "5px",
                fontSize: "16px",
              }}
            >
              Result Payload:
            </label>
            <textarea
              id="resultPayload"
              placeholder="Result Payload"
              value={resultPayload}
              onChange={(e) => this.setState({ resultPayload: e.target.value })}
              style={{
                width: "100%",
                padding: "5px",
                fontSize: "14px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
              }}
              required
              rows={3}
            ></textarea>
          </div>

          <button
            type="submit"
            style={{
              padding: "8px 16px",
              fontSize: "14px",
              border: "none",
              borderRadius: "4px",
              backgroundColor: "#007bff",
              color: "#fff",
              cursor: "pointer",
            }}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    );
  }
}

export default PayloadForm;
